import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const Laroute = require('../../laroute');

const state = {
    lastQuery: null,
    zoneList: [],
};

const mutations = {
    [type.SET_ZONE_LIST](state, zone) {
        state.zoneList = zone;
    },

    [type.ADD_ZONE](state, zone) {
        state.zoneList.push(zone);
    },
};

const getters = {
    zones(state) {
        return state.zoneList;
    },
};

const actions = {
    getZones({ commit }, params) {
        let route = Laroute.route('franchise.vue.zone');

        let options = {
            params: _.merge(
                {
                    limit: 10,
                    query: null,
                },
                params,
            ),
        };

        axios.get(route, options).then(res => {
            commit(type.SET_ZONE_LIST, res.data.data);
        });
    },

    getZone({ commit, dispatch }, id) {
        let route = Laroute.route('franchise.zone.show', {
            id: id,
        });
        startLoading(dispatch, 'fetch-zone');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'fetch-zone');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-zone');
                throw err;
            });
    },

    getZoneListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.zoneList.length || state.lastQuery !== params.query) {
            return dispatch('getZones', params);
        }

        return Promise.resolve(state.zoneList);
    },

    updateZone({ commit, dispatch }, zone) {
        let route = Laroute.route('franchise.zone.update', {
            id: zone.id,
        });
        startLoading(dispatch, 'save-zone');

        return axios
            .patch(route, zone)
            .then(res => {
                endLoading(dispatch, 'save-zone');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-zone');
                throw err;
            });
    },

    createZone({ commit, dispatch }, zone) {
        let route = Laroute.route('franchise.zone.store');
        startLoading(dispatch, 'save-zone');

        return axios
            .post(route, zone)
            .then(res => {
                commit(type.ADD_ZONE, res.data);
                endLoading(dispatch, 'save-zone');

                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-zone');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/zone.js